import { render, staticRenderFns } from "./UniSelect.vue?vue&type=template&id=09319a66&scoped=true&"
import script from "./UniSelect.vue?vue&type=script&lang=js&"
export * from "./UniSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UniSelect.vue?vue&type=style&index=1&id=09319a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09319a66",
  null
  
)

export default component.exports